"use strict";

module.exports = function () {
  return !!(this.opts.childRow || this.$parent.$scopedSlots.child_row);
};


//////////////////
// WEBPACK FOOTER
// ./~/vue-tables-2-premium/compiled/computed/has-child-row.js
// module id = 861
// module chunks = 0